import { createStore, applyMiddleware, combineReducers } from 'redux';
import { persistStore, autoRehydrate } from 'redux-persist';
import { asyncSessionStorage } from 'redux-persist/storages';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

import { clientReducer } from './client.redux';
import { loadingReducer } from './loading.redux';
import { errorReducer } from './error.redux';
import { flowReducer } from './flow.redux';
import { uiReducer } from './ui.redux';

export const reducer = combineReducers({
  client: clientReducer,
  error: errorReducer,
  flow: flowReducer,
  loading: loadingReducer,
  ui: uiReducer,
});

const store = createStore(reducer, composeWithDevTools(applyMiddleware(thunk)), autoRehydrate());

persistStore(store, {
  storage: asyncSessionStorage,
  whitelist: ['client', 'flow'],
});

export default store;
